export const internationalBanks = [
  // North America
  { country: "USA", name: "US Bank", code: "USBKUS44" },
  { country: "USA", name: "JPMorgan Chase Bank", code: "CHASUS33" },
  { country: "USA", name: "Bank of America", code: "BOFAUS3N" },
  { country: "USA", name: "Wells Fargo Bank", code: "WFBIUS6S" },
  { country: "USA", name: "Citibank", code: "CITIUS33" },
  { country: "Canada", name: "Royal Bank of Canada", code: "ROYCCAT2" },
  { country: "Canada", name: "Toronto-Dominion Bank", code: "TDOMCATTTOR" },
  { country: "Canada", name: "Bank of Nova Scotia", code: "NOSCCATT" },
  { country: "Canada", name: "Bank of Montreal", code: "BOFMCAM2" },
  
  // Europe
  { country: "UK", name: "Barclays Bank", code: "BARCGB22" },
  { country: "UK", name: "HSBC Bank", code: "HSBCGB2L" },
  { country: "UK", name: "Lloyds Bank", code: "LOYDGB2L" },
  { country: "UK", name: "NatWest Bank", code: "NWBKGB2L" },
  { country: "Germany", name: "Deutsche Bank", code: "DEUTDEFF" },
  { country: "Germany", name: "Commerzbank", code: "COBADEFF" },
  { country: "France", name: "BNP Paribas", code: "BNPAFRPP" },
  { country: "France", name: "Société Générale", code: "SOGEFRPP" },
  { country: "France", name: "Crédit Agricole", code: "AGRIFRPP" },
  { country: "Switzerland", name: "UBS Switzerland", code: "UBSWCHZH80A" },
  { country: "Switzerland", name: "Credit Suisse", code: "CRESCHZZ80A" },
  { country: "Netherlands", name: "ING Bank", code: "INGBNL2A" },
  { country: "Netherlands", name: "ABN AMRO Bank", code: "ABNANL2A" },
  { country: "Spain", name: "Banco Santander", code: "BSCHESMM" },
  { country: "Spain", name: "BBVA", code: "BBVAESMM" },
  { country: "Italy", name: "UniCredit Bank", code: "UNCRITMMXXX" },
  { country: "Italy", name: "Intesa Sanpaolo", code: "BCITITMM" },
  
  // Asia
  { country: "China", name: "Bank of China", code: "BKCHCNBJ" },
  { country: "China", name: "Industrial and Commercial Bank of China", code: "ICBKCNBJ" },
  { country: "China", name: "China Construction Bank", code: "PCBCCNBJ" },
  { country: "Japan", name: "Mitsubishi UFJ Bank", code: "BOTKJPJT" },
  { country: "Japan", name: "Sumitomo Mitsui Banking Corporation", code: "SMBCJPJT" },
  { country: "Japan", name: "Mizuho Bank", code: "MHCBJPJT" },
  { country: "Singapore", name: "DBS Bank", code: "DBSSSGSG" },
  { country: "Singapore", name: "United Overseas Bank", code: "UOVBSGSG" },
  { country: "Singapore", name: "OCBC Bank", code: "OCBCSGSG" },
  { country: "Hong Kong", name: "HSBC Hong Kong", code: "HSBCHKHH" },
  { country: "Hong Kong", name: "Bank of China (Hong Kong)", code: "BKCHHKHH" },
  { country: "Hong Kong", name: "Hang Seng Bank", code: "HASEHKHH" },
  { country: "India", name: "State Bank of India", code: "SBININBB" },
  { country: "India", name: "HDFC Bank", code: "HDFCINBB" },
  { country: "India", name: "ICICI Bank", code: "ICICINBB" },
  { country: "South Korea", name: "KB Kookmin Bank", code: "CZNBKRSE" },
  { country: "South Korea", name: "Shinhan Bank", code: "SHBKKRSE" },
  
  // Middle East
  { country: "UAE", name: "Emirates NBD", code: "EBILAEAD" },
  { country: "UAE", name: "Abu Dhabi Commercial Bank", code: "ADCBAEAA" },
  { country: "UAE", name: "First Abu Dhabi Bank", code: "NBADAEAA" },
  { country: "Saudi Arabia", name: "National Commercial Bank", code: "NCBKSAJE" },
  { country: "Saudi Arabia", name: "Al Rajhi Bank", code: "RJHISARI" },
  { country: "Qatar", name: "Qatar National Bank", code: "QNBAQAQA" },
  
  // Australia & Pacific
  { country: "Australia", name: "Commonwealth Bank of Australia", code: "CTBAAU2S" },
  { country: "Australia", name: "Westpac Banking Corporation", code: "WPACAU2S" },
  { country: "Australia", name: "ANZ Bank", code: "ANZBAU3M" },
  { country: "Australia", name: "National Australia Bank", code: "NATAAU33" },
  { country: "New Zealand", name: "ANZ Bank New Zealand", code: "ANZBNZ22" },
  { country: "New Zealand", name: "Bank of New Zealand", code: "BKNZNZ22" },
  
  // Africa
  { country: "South Africa", name: "Standard Bank", code: "SBZAZAJJ" },
  { country: "South Africa", name: "FirstRand Bank", code: "FIRNZAJJ" },
  { country: "South Africa", name: "Nedbank", code: "NEDSZAJJ" },
  { country: "Nigeria", name: "Guaranty Trust Bank", code: "GTBINGLA" },
  { country: "Nigeria", name: "Zenith Bank", code: "ZEIBNGLA" },
  
  // South America
  { country: "Brazil", name: "Banco do Brasil", code: "BRASBRRJ" },
  { country: "Brazil", name: "Itaú Unibanco", code: "ITAUBRSP" },
  { country: "Brazil", name: "Bradesco", code: "BBDEBRSP" },
  { country: "Mexico", name: "BBVA Bancomer", code: "BCMRMXMM" },
  { country: "Mexico", name: "Banamex (Citibank)", code: "BNMXMXMM" },
  { country: "Argentina", name: "Banco de la Nación Argentina", code: "NACNARBA" },
];
